export default "__VITE_PUBLIC_ASSET__960d18ae__"